import { getCookie, removeCookie } from 'App/helpers/cookieHelper';

// Written by ui-3's `lib/integrations/oauthReturn.ts` — the name is shared by hand across
// the two apps, and the cookie is the only thing telling us the flow started over there.
const RETURN_COOKIE = 'ui3OauthReturn';

const LANDING_HASH = /^#\/oauthLanding\/(\d+)(?:\/([^/?]+))?(\?.*)?$/;

// Any upsales.com subdomain can write a cookie on `.upsales.com`, and this redirect carries
// the oauth code — so only a host that could be ui-3 itself is allowed to aim it.
function isUi3Origin(origin: string) {
	if (window.location.hostname === 'localhost') {
		return /^http:\/\/localhost:\d+$/.test(origin);
	}
	return /^https:\/\/[a-z0-9-]+\.upsales\.com$/.test(origin);
}

function readReturnOrigin() {
	const raw = getCookie(RETURN_COOKIE);
	if (!raw) {
		return null;
	}
	const origin = decodeURIComponent(raw);
	return isUi3Origin(origin) ? origin : null;
}

export function bounceOauthReturnToUi3() {
	const landing = LANDING_HASH.exec(window.location.hash);
	if (!landing) {
		return false;
	}
	const origin = readReturnOrigin();
	if (!origin) {
		return false;
	}

	const sharedDomain = window.location.hostname.endsWith('.upsales.com') ? '.upsales.com' : undefined;
	removeCookie(RETURN_COOKIE, '/', sharedDomain);

	const [, integrationId, type, search = ''] = landing;
	window.location.replace(`${origin}/apps/${integrationId}${type === 'user' ? '/user' : ''}${search}`);
	return true;
}
